import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  tag: {
    font: {
      size: '1.2rem',
      lineHeight: '2.4rem',
      weight: 400,
    },
    textAlign: 'center',
    color: colors.neutral[900],
    backgroundColor: colors.neutral[200],
    width: '8.8rem',
    verticalAlign: 'middle',
    borderRadius: '14px',
    margin: 0,
  },
  notCoveredTag: {
    backgroundColor: colors.neutral[200],
  },
  coveredTag: {
    backgroundColor: colors.green[100],
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
